import HeaderLayout from "../../../Layout/HeaderLayout";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import { actions } from "../../../Store/reducer";
import species from "../../../Services/species";
import archetypes from "../../../Services/archetypes";
import { CONFIG_PLAYER_PATH } from "../../../Services/routeNames";
import { nameByRace } from "fantasy-name-generator";
import './customizationCharacterPlayer.scss';

export default function CustomisationCharacterPlayer() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [speciesId, setSpeciesId] = useState<string>("");
    const [archetypeId, setArchetypeId] = useState<string>("");
    const [characterName, setCharacterName] = useState<string>("");

    function getRandomName(): string {
        return nameByRace("human") as string;
    }

    function isValid(): boolean {
        return characterName !== "" && speciesId !== "" && archetypeId !== "";
    }

    function validate() {
        if (!isValid())
            return;

        dispatch({
            type: actions.player.SET_CHARACTER_INFO,
            payload: {
                player: {
                    characterInfo: {
                        name: characterName,
                        species: speciesId,
                        archetype: archetypeId,
                    },
                }
            },
        });

        navigate(CONFIG_PLAYER_PATH);
    }


    return (
        <div className="character-customization">
            <HeaderLayout currentPage="customization" hamburger={true} isPlayer={true}>
                <span>Création de personnage</span>
            </HeaderLayout>

            <div className="random-name">
                <div className="randomizer">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 99.48" onClick={() => setCharacterName(getRandomName())}>
                        <g fill="#ec672a"><path d="m50,0C22.43,0,0,22.31,0,49.74s22.43,49.74,50,49.74,50-22.31,50-49.74S77.56,0,50,0Zm-21.83,69.78c-1.3,1.3-1.8,1.88-2.84,2.32s-2.29.38-3.98.38h-9.09v-9.09h9.09c.22,0,.24.05.43-.14l6.54-6.54,6.39,6.39-6.54,6.68Zm59.2-1.88s0,.06-.01.09h0c-.03.17-.11.32-.25.42l-16.32,12.54c-.24.18-.57.18-.81,0-.24-.18-.33-.5-.22-.78l2.43-6.14c.3-.77-.26-1.61-1.09-1.61h-.93s-7.91,0-7.91,0c-3.38,0-5.26-1.15-7.25-3.13l-26.7-26.56h0s-6.54-6.53-6.54-6.53c-.19-.19-.2-.14-.43-.14h-9.09v-9.09h9.09c1.69,0,2.93-.06,3.98.38s1.54,1.02,2.84,2.32l6.54,6.68h0s26.7,26.56,26.7,26.56c.28.28.56.43.85.43h4.62s4.22,0,4.22,0c.83,0,1.4-.83,1.09-1.61l-2.43-6.14c-.11-.28-.02-.6.22-.78.24-.18.57-.18.81,0l16.32,12.54c.14.11.22.26.25.42h0s.01.06.01.09c0,0,0,0,0,0s0,0,0,0Zm.37-36.23h0c-.03.17-.11.32-.25.42l-16.32,12.54c-.24.18-.57.18-.81,0s-.33-.5-.22-.78l2.43-6.14c.3-.77-.26-1.61-1.09-1.61h-4.22s-4.99,0-4.99,0c-.29,0-.57.14-.85.43l-6.25,6.11-6.39-6.39,6.25-6.11c1.98-1.98,3.86-3.13,7.25-3.13h4.99s4.22,0,4.22,0c.83,0,1.4-.83,1.09-1.61l-2.43-6.14c-.11-.28-.02-.6.22-.78.24-.18.57-.18.81,0l16.32,12.54c.14.11.22.26.25.42h0s.01.06.01.09c0,0,0,0,0,0,0,0,0,0,0,0,0,.03,0,.06-.01.09Z" /></g>
                    </svg>
                </div>
                <div className="name">
                    <label>Nommez votre personnage</label>
                    <input value={characterName} onChange={e => setCharacterName(e.target.value)} />
                </div>
            </div>

            <div className="species">
                <div>
                    <label className="label-custom">Choisissez son espèce</label>
                    <select value={speciesId} onChange={e => setSpeciesId(e.target.value)}>
                        <option value="">--</option>
                        {Object.keys(species).map(key => {
                            return <option
                                key={key}
                                value={key}
                                label={species[key].name}
                            />
                        })}
                    </select>
                </div>
            </div>

            <div className="archetypes">
                <div>
                    <label className="label-custom">Archetype</label>
                    <select value={archetypeId} onChange={e => setArchetypeId(e.target.value)}>
                        <option value="">--</option>
                        {Object.keys(archetypes).map(key => {
                            return <option
                                key={key}
                                value={key}
                                label={archetypes[key].name[(species[speciesId] && species[speciesId].gender) ?? 'male']}
                            />
                        })}
                    </select>
                </div>
            </div>

            <div className="validate">
                <div className={isValid() ? "button enable" : "button"} style={{ opacity: isValid() ? 1 : .5, cursor: isValid() ? "pointer" : "default" }} onClick={validate}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 95"><g fill="#ec6223"><polygon points="447.12 0 0 16.23 1.42 55.16 1.68 62.08 2.88 95 450 78.77 447.12 0" /></g></svg>
                    <span>Valider</span>
                </div>
            </div>
        </div>
    );
}